import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Toaster — notificaciones de feedback (FORJA editorial).
 *
 * Una sola instancia montada en el root (main.tsx). Tema claro/papel,
 * tipografía Manrope heredada, posición top-center, richColors (éxito=verde,
 * error=rojo) y botón de cierre. Los tokens de marca se inyectan vía
 * --normal-* para que el toast neutro use papel + negro editorial.
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      position="top-center"
      richColors
      closeButton
      toastOptions={{
        style: {
          fontFamily: "var(--font-sans)",
        },
      }}
      style={
        {
          "--normal-bg": "var(--card)",
          "--normal-text": "var(--foreground)",
          "--normal-border": "var(--border)",
          fontFamily: "var(--font-sans)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
}
